var $gallery_item;

var img_width  = 0;
var img_height = 0;

var window_height = 0;
var margins = 0;
var gallery_width = 2; // 2px extra for uneven numbers when resizing images
var current_slide_item;
var current_slide_item_width;
var images_loaded = false;

adaptive_images();

function adaptive_images(){
       if($(window).width() >= 700){
              var t = $(".gallery_img").each(function(){
                     $(this).attr("src",$(this).attr("src").replace("grande","1024x1024"));
              });
       }
}

$(document).ready(function(){
       init_gallery();            
});

$(window).resize(function(){
       window_height = 0;
       gallery_width = 2;
        
       resize();
       
       adaptive_images();
       //load_images_and_resize();
       gallery_scroll();
});

$(window).scroll(function(){
	gallery_scroll();
});

function init_gallery(){
       $(".gallery_item:first").addClass("active");
       
       // scale the minislideshow inside the .gallery_product   ( in jquery.basic.js )
       resize_product_slides_and_container(".gallery_product", ".product_slide_container");
       
       load_images_and_resize();
       
       hor_scroll();
       
       gallery_scroll();
       
       add_gallery_navigation();
}

function load_images_and_resize(){
       
       if($(window).width() >= 600){
              window_height = $(window).height();
              margins = parseInt($(".gallery #content").css("marginTop")) + 20;
              $(".gallery #content, .gallery_product").height( window_height -  margins );  
       }else{
              $(".gallery #content").height("auto");
       }
       
       // WAIT FOR IMAGES LOADED
       $('.gallery_item .gallery_slides').imagesLoaded( function() {
              
       })
       .always( function( instance ) {
              /*
              $(".gallery_product").each(function(){
                     var prd_width = $(this).width();
                     gallery_width = gallery_width + prd_width;
                     log("prd_width",prd_width);
                     
                     if($(window).width() >= 600){
                            $("#content").width(gallery_width);
                            //log("gallery_prd_width",prd_width);
                     }else{
                            $(".gallery #content").width($(window).width());
                     }                   
                     
                     $(this).removeClass("offscreen");
              });
              */
       })
       .done( function( instance ) {
              //console.log('all images successfully loaded');
              images_loaded = true;
       })
       .fail( function() {
              //console.log('all images loaded, at least one is broken');
              images_loaded = true;
       })
       
       // PROGRESS
       .progress( function( instance, image ) {
              var result = image.isLoaded ? 'loaded' : 'broken';

              if(result === "loaded"){
                     
                     show_image(image);
                     
              }
       });
};



// SHOW IMAGE AFTER IT IS LOADED AND EXPAND #content
function show_image(image){
       
       if($(window).width() >= 600){
              var $item = $(image.img);
              img_width = Math.ceil(parseInt($item.width()));
       
              gallery_width += img_width;       
              $("#content").width(gallery_width);
              
              if(images_loaded === false){
                     $item.css("opacity",0);
                     $item.removeClass('offscreen');

                     $item.animate().animate({
                            opacity: 1
                            }, 2000, function() {
                            // Animation complete.
                            });
              }
       
       }else{
              $(".gallery #content").width("100%");
       }
       
};

function gallery_scroll(){
       
       var scrolled_left = $(document).scrollLeft();
       var nav_btn_w = $(".gallery_navigation.next.visible").width();
       
       var diff = $(".gallery_item.active .gallery_slides").offset().left + $(".gallery_item.active .gallery_slides").width() - $(window).width();
       var diffplus = diff + $(".gallery_item.active .gallery_product").width();
       
       
       // produktansicht ist mehr als sichtbar > relativ positioniert und visible
       if(scrolled_left >= diffplus - nav_btn_w){
              //log("state","1");
              if($(".gallery_item.active").next(".gallery_item").length > 0 ){
                     if(scrolled_left >= diffplus){
                            //console.log("1a");
                            $(".gallery_item.active .gallery_product").stop().removeClass("fixed");  

                            $(".gallery_item.active .gallery_product").addClass("visible"); 
                            $(".gallery_item.active .gallery_product").css("right",0); 

                            var next = $(".gallery_item.active").next(".gallery_item");       
                            $(".gallery_item.active").removeClass("active");
                            next.addClass("active"); 
                     }
              }else{
                     //log("state","1b");
                     $(".gallery_item.active .gallery_product").stop();  

                     $(".gallery_item.active .gallery_product").addClass("visible"); 
                     $(".gallery_item.active .gallery_product").css("right",nav_btn_w);       
                     
              }
              
       }
       // ab der hälfte des aktiven gallery items 
       else if(scrolled_left >= ( diff - ($(".gallery_item.active").width() * 0.3) )){
              //log(" in active area",diff);
              // sichtbar von links kommend > fixed am rechten rand
              $(".gallery_item.active .gallery_product.visible").filter(':not(:animated)').not('.fixed').addClass("fixed").css("right",nav_btn_w);
              
              // unsichtbar von rechts kommend > vorbereitung zur animation
              // animation
              $(".gallery_item.active .gallery_product").filter(':not(:animated)').not('.fixed, .visible').addClass("fixed visible").css("right",-$(".gallery_item.active .gallery_product").width()).animate({
                     right: nav_btn_w 
                     }, 500, function() {
                     
              });   
       }
       // produktansicht ist rechts außerhalb > relativ positioniert aber unsichtbar
       else if(scrolled_left <= diff){
             $(".gallery_item.active .gallery_product.visible.fixed").filter(':not(:animated)').animate({
                     right: -$(".gallery_item.active .gallery_product").width()
                     }, 500, function() {
                     $(".gallery_item.active .gallery_product").removeClass("fixed visible");; 
             }); 
             
             // 
             var w = $(".gallery_item.active").offset().left;
             if(scrolled_left + $(window).width() <= w + nav_btn_w){
                     if($(".gallery_item.active").prev(".gallery_item").length > 0 ){
                            var prev = $(".gallery_item.active").prev(".gallery_item");       
                            $(".gallery_item.active").removeClass("active");
                            prev.addClass("active");
                     }                    
             }
             
       }
       
       //log("scrolled_left",scrolled_left);
       //log("window.width",$(window).width());
       //log("diffplus",diffplus);
       //log("prod_offset",$(".gallery_product").offset().left);
       //log("diff",diff);
       //log("prod_width",$(".gallery_item.active .gallery_product").width());
       //log("w",w);
};

function resize(){
       
       adaptive_images();
       
       if($(window).width() >= 600){
              
              window_height = $(window).height();
              margins = parseInt($(".gallery #content").css("marginTop")) + 20;
              $(".gallery #content, .gallery_product").height( window_height -  margins ); 
              
              $(".gallery_slides").each(function(i){
                     current_slide_item = $(this);
                     current_slide_item_width = 0; 

                     $(this).find("img").each(function(){
                        current_slide_item_width += $(this).width();    
                     });

                     gallery_width += current_slide_item_width;       
                     $(".gallery #content").width(gallery_width);
              });

              /*
              $(".gallery_product").each(function(i){
                     gallery_width += Math.ceil($(this).width());
                     $(".gallery #content").width(gallery_width);
              });
              */
              
       }else{
              $(".gallery #content").width("100%");
              $(".gallery #content").height("auto");
       }
       
};
       
function add_gallery_navigation(){
       //$(".gallery_navigation").addClass("visible");
       //$(".gallery #content").css("margin-left","20px");
       //$(".gallery #content").css("margin-right","20px");
};

function hor_scroll(){
       $(window).bind('mousewheel DOMMouseScroll', function(event){
              if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
                     var y = $(window).scrollLeft();  //your current y position on the page
                     if($(window).width() >= 600 && $('#popup_container:hover').length == 0 ){
                            event.preventDefault();
                            $(window).scrollLeft(y - 50);       
                     }
              }
              else {
                     var y = $(window).scrollLeft();  //your current y position on the page
                     if($(window).width() >= 600 && $('#popup_container:hover').length == 0 ){
                            event.preventDefault();
                            $(window).scrollLeft(y + 50);       
                     }
              }
       }); 
}
